import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { Testimonials } from './components/Testimonials';
import { TriangleMechanism } from './components/TriangleMechanism';
import { FAQ } from './components/FAQ';
import { ImmersionSection } from './components/ImmersionSection';
import { OfferBlock } from './components/OfferBlock';
export function App() {
  return <div className="min-h-screen bg-background text-gray-100 font-sans selection:bg-primary/30 selection:text-white" data-id="element-0">
      <div className="h-1 w-full bg-primary" data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <Testimonials data-id="element-5" />
        <TriangleMechanism data-id="element-6" />
        <ImmersionSection data-id="element-7" />
        <OfferBlock data-id="element-8" />
        <FAQ data-id="element-9" />
      </main>

      <footer className="py-8 text-center text-gray-500 text-sm border-t border-white/10 mt-10" data-id="element-10">
        <p data-id="element-11">
          Lucas Torres - El Código del Dinero. Todos los derechos reservados
          2026.
        </p>
      </footer>
    </div>;
}